import { gql } from '@apollo/client';

const HOLTER_RR_HEATMAP_OVERVIEW = gql`
  query holterRrHeatMapOverview($filter: HolterRrHeatMapOverviewFilter!) {
    holterRrHeatMapOverview(filter: $filter) {
      isSuccess
      message
      rrHeatMapOverview {
        rrHeatMapType
        reviewed
        total
      }
    }
  }
`;

export default HOLTER_RR_HEATMAP_OVERVIEW;
